const items = document.querySelectorAll('.generator-for-pdf-button');
if (items.length > 0) {
    items.forEach(item => {
        // Find the link and add an event listener
        let linkTag = item.querySelector('a');
        if(!linkTag) return;
        linkTag.addEventListener('click', function (e) {

            e.preventDefault();

            if(linkTag.classList.contains('loading')){
                return false;
            }

            const loader = document.createElement("div");
            loader.classList.add('generator-for-pdf-loader');
            loader.innerHTML = '<div class="spinner">' + generatorForPdf.pdfLoader + '</div>';
            linkTag.appendChild(loader);
            linkTag.classList.add('loading');

            setTimeout(() => {
                loader.classList.add('show');
            }, 10);


            // Get link data
            let href = linkTag.getAttribute('href');


            const downloadFile = async (remoteUrl) => {
                try {
                    fetch(remoteUrl)
                        .then(response => {
                            const disposition = response.headers.get('Content-Disposition');
                            const filenameMatch = disposition && disposition.match(/filename="(.+)"/);
                            const filename = filenameMatch ? filenameMatch[1] : 'pdf-download.pdf';

                            return response.blob().then(blob => ({ blob, filename }));
                        })
                        .then(({ blob, filename }) => {

                            loader.classList.remove('show');
                            linkTag.classList.remove('loading');

                            const url = URL.createObjectURL(blob);
                            const a = document.createElement('a');
                            a.href = url;
                            a.download = filename;
                            document.body.appendChild(a);
                            a.click();
                            a.remove();
                        });


                } catch (error) {
                    console.error("Download failed:", error);
                }
            };

            // Download file
            downloadFile(href);


        });
    });
}